import React from 'react';
import { screenNames, routes } from './routes_const';

const Welcome = React.lazy(() => import('../../pages/welcome'));
const Wizard = React.lazy(() => import('../../pages/wizard'));
const Reading = React.lazy(() => import('../../pages/reading'));
const Spinner = React.lazy(() => import('../spinner'));

const routesComponents = {
  [screenNames.welcome]: Welcome,
  [screenNames.wizard.aboutMe]: Wizard,
  [screenNames.wizard.question]: Wizard,
  [screenNames.wizard.advisorSelection]: Wizard,
  [screenNames.wizard.payment]: Wizard,
  [screenNames.wizard.whatsNext]: Wizard,
  [screenNames.reading]: Reading
};

export const generateRoutesData = (useSpinnerRoutes) => {
  const updatedRoutes = { ...routes };

  Object.keys(routes).forEach((key) => {
    updatedRoutes[key].Component = useSpinnerRoutes ? Spinner : routesComponents[key];
  });

  return updatedRoutes;
};
